import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PassengersReportService } from '../../services/passengers-report.service';
import { CommonService } from '../../services/common.service';
import { ExcelService } from '../../services/excel.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormsModule } from '@angular/forms';
import { NgSelectOption } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DriversService } from '../../services/drivers.service';
import * as $ from 'jquery';
import swal from 'sweetalert2';
import { UsersService } from '../../services/users.services';
import { delay } from 'rxjs/operator/delay';
import { RoutesService } from '../../services/routes.service';
import { ConsolidatedByPlateService } from '../../services/consolidated-by-plate.service';

declare var $: any;

@Component({
  selector: 'app-timereportconsolidate',
  templateUrl: './timereportconsolidate.component.html',
  styleUrls: ['./timereportconsolidate.component.css']
})
export class TimereportconsolidateComponent implements OnInit {

	platesBuffer = [];
	loading1 = false;
	bufferSize = 50;
	imeiVei: any = {};
	vehiculo: any = {};
	dataObj: any = [];
	user_account: any;
	data: any = [];
	placas: any = [];
	report: any = [];
	reportAux: any = [];
	model: any = {};
	returnUrl: string;
	isSubmitted: any = false;
	dataReport: any = [];
	dataReport2: any = [];
	totalIn: any;
	totalOut: any;
	promTot: any;
	totalProm: any;
	totalPromInTime: any;
	totalPromOuitTime: any;
	dateNowInit: any;
	dateNowEnd: any;
	public loading = false
	selectedCity: any;
	filterMenuVisible: boolean = false;
	displayedColumns: string[];


	plates: any = [];
	platesSettings = {};
	selectedPlates = [];

	drivers = []
	driversSettings = {};
	selectedDrivers = [];

	dispatchers = []
	dispatchersSettings = {};
	selectedDispatchers = [];

	routes = []
	routesSettings = {};
	selectedRoutes = [];

	@ViewChild(MatPaginator) paginator: MatPaginator;
  	@ViewChild(MatSort) sort: MatSort;

	constructor(
		private route: ActivatedRoute,
	    private router: Router,
	    private vpcReportService: PassengersReportService,
	    private consolidatedByPlateService: ConsolidatedByPlateService,
	    private excelService: ExcelService,
	    private commonService: CommonService,
	    private spinner: NgxSpinnerService,
	    private driversService: DriversService,
	    private routesService: RoutesService,
   	) { }

  	ngOnInit() {
  		this.getPlates();
	    this.getDrivers();
	    this.setFilterstData();
  	}

  	 setFilterstData() {
    var now = new Date(); //currentDate
    this.reportAux.dateIni = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.reportAux.dateFin = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.reportAux.timeIni = '00:00';
    this.reportAux.timeFin = '23:59';
    this.reportAux.rfidOnly = 1
  }

  getDrivers(): void {

    this.driversSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.driversService.getDrivers_rol(this.commonService.getUserName())
      .then(response => {
        console.log(response)
        this.drivers = response
      });
  }

  loadReport(): void {
    console.log(this.reportAux)
    this.dataObj = [];
    //console.log('this.imeiVei : ', this.imeiVei.sn_imei_id)
    var d1, m1, d2, m2;
    if (this.reportAux.dateIni.day < 10) {
      d1 = '0' + this.reportAux.dateIni.day;
    } else {
      d1 = this.reportAux.dateIni.day;
    }
    if (this.reportAux.dateIni.month < 10) {
      m1 = '0' + this.reportAux.dateIni.month;
    } else {
      m1 = this.reportAux.dateIni.month;
    }
    var dateIni = d1 + '-' + m1 + '-' + this.reportAux.dateIni.year + ' ' + this.reportAux.timeIni;

    if (this.reportAux.dateFin.day < 10) {
      d2 = '0' + this.reportAux.dateFin.day;
    } else {
      d2 = this.reportAux.dateFin.day;
    }
    if (this.reportAux.dateFin.month < 10) {
      m2 = '0' + this.reportAux.dateFin.month;
    } else {
      m2 = this.reportAux.dateFin.month;
    }
    var dateFin = d2 + '-' + m2 + '-' + this.reportAux.dateFin.year + ' ' + this.reportAux.timeFin;
    dateIni = dateIni.replace(':', '_');
    dateFin = dateFin.replace(':', '_');
    //console.log(dateIni);
    //console.log(dateFin);
    //if (this.imeiVei == undefined) {
      $('.tbodyTable').empty();
      //var dateIni = $('#dateIni').val().replace(':', '_');
      //var dateFin = $('#dateFin').val().replace(':', '_');
      //console.log(dateIni);
      var imeis = this.selectedPlates.map(({ sn_imei_id }) => "'" + sn_imei_id + "'").toString();

      console.log(imeis)
      if(imeis == ""){
        swal({
          title: 'Debe seleccionar al menos una Placa',
          text: '',
          type: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
        return
      }

      var driversId = this.selectedDrivers.map(({ id }) => "'" + id + "'").toString();
      this.spinner.show();
      if (dateIni && dateFin) {
        //var rfidOnly = this.reportAux.rfidOnly == true ? "1": "0"
        this.consolidatedByPlateService.timeReportConsolidate(imeis, dateIni, dateFin,
          this.reportAux.rfidOnly, driversId)
          .then(data => {
            console.log('data dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa : ', data)
            this.dataReport = [];
            // $('.tbodyTable').empty();
            this.spinner.hide();
            this.report = data;

            // const dateValidate = new Date('2018-01-01 00:00:00.00');
            // const dateValidateSum = new Date('2018-01-01 00:00:00.00');
            // let trip = 0;
            // let totalIn = 0;
            // let totalOut = 0;
            // let promTot = 0;


            const quant = parseInt(data.length);
            if (quant > 0) {
              //   $('.tbodyTable').empty();
              //   for (let i = 0; i < data.length; i++) {
              //     data[i].trip = trip
              //     // data[i].plate = this.imeiVei.tracker_name;
              //     const dateArray = new Date(data[i].startdate);
              //     if (dateArray < dateValidate || dateArray > dateValidateSum) {
              //       var it = {};
              //       trip = trip + 1
              //       data[i].trip = trip
              //       it["Viaje"] = trip;
              //       it["Placa"] = data[i].plate;
              //       it["Ruta"] = data[i].route;
              //       it["Fecha"] = data[i].registerTime;
              //       it["Bloqueos"] = data[i].countBlock;
              //       it["Kms recorridos"] = data[i].journey;
              //       it["Velocidad máxima"] = data[i].speed;
              //       it["Hora inicio"] = data[i].startTime;
              //       it["Hora fin"] = data[i].endTime;
              //       it["Ingresos puerta trasera"] = data[i].backdoorin;
              //       console.log('backdoorin : ', data[i].backdoorin)
              //       it["Pasajeros movilizados"] = data[i].totalProm;
              //       console.log('totalProm : ', data[i].totalProm)
              //       it["Tiempo de viaje"] = data[i].time;
              //       console.log('time : ', data[i].time)
              //       console.log('dataaaaa : ', data[i])
              //       this.dataReport.push(data[i]);
              //       this.dataObj.push(it);
              //     }
              //     console.log('this.dataObj : ', this.dataObj)
              //     dateValidateSum.setMinutes(dateValidateSum.getMinutes() + 10);
              //     event.preventDefault();
              //     totalIn = totalIn + parseInt(data[i]['totalInPass']);
              //     totalOut = totalOut + parseInt(data[i]['totalOutPass']);
              //   }
              //   this.totalIn = totalIn;
              //   console.log('this.totalIn : ', this.totalIn)
              //   this.totalOut = totalOut;
              //   console.log('this.totalOut : ', this.totalOut)
              //   this.totalProm = Math.round((this.totalIn + this.totalOut) / 2);

              this.setTable(data)
            } else {
              $('.tbodyTable').empty();
              swal({
                title: 'No existen datos para este rango de fechas',
                text: '',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#ff5370',
                confirmButtonText: 'Volver',
                // cancelButtonText: 'No'
              }).catch(swal.noop);
            }
          })
          .catch(error => {
            this.spinner.hide();
            console.log(error)
            // console.log('vpcReport.component.error');
            swal({
              title: 'No es posible realizar la consulta, comuníquese con el administrador del sistema',
              text: '',
              type: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#ff5370',
              confirmButtonText: 'Volver',
              // cancelButtonText: 'No'
            }).catch(swal.noop);
          });
      } else {
        this.spinner.hide();
        swal({
          title: 'Ingresa Todos los campos solicitados',
          text: '',
          type: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#ff5370',
          confirmButtonText: 'Volver',
          // cancelButtonText: 'No'
        }).catch(swal.noop);
      }
    // } else {

    // }
  }

  getPlates(): void {

    this.platesSettings = {
      singleSelection: false,
      idField: 'sn_imei_id',
      textField: 'tracker_name',
      selectAllText: 'Todos',
      unSelectAllText: 'Deseleccionar Todos',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      searchPlaceholderText: "Buscar"
    };

    this.spinner.show();
    this.vpcReportService.getPlates(this.commonService.getUserName()).then(response => {
      console.log(response)
      this.plates = response;
      this.plates.sort(function (a, b) {
        if (a.tracker_name > b.tracker_name) {
          return 1;
        }
        if (a.tracker_name < b.tracker_name) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });

      for (var i in this.plates) {
        this.plates[i].tracker_name = this.plates[i].tracker_name + " - " + this.plates[i].license_plate
      }
      console.log('response : : : ', this.plates)
      this.platesBuffer = this.plates.slice(0, this.bufferSize);
      this.user_account = this.plates.user_account;
      this.imeiVei = this.plates.sn_imei_id;
    });
    this.spinner.hide();
  }

  fetchMorePlate() {
    const len = this.platesBuffer.length;
    const more = this.plates.slice(len, this.bufferSize + len);
    this.loading1 = true;
    // using timeout here to simulate backend API delay
    setTimeout(() => {
      this.loading1 = false;
      this.platesBuffer = this.platesBuffer.concat(more);
    }, 200);
  }
  exportToExcel() {
    if (this.dataObj.length > 0) {
      this.excelService.exportAsExcelFile(this.dataObj, 'archivo_conteo_pasajeros');
    } else {
      swal({
        title: 'No hay datos para exportar',
        text: '',
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#ff5370',
        confirmButtonText: 'Volver',
        // cancelButtonText: 'No'
      }).catch(swal.noop);
    }
  }

  setTable(data) {
    this.displayedColumns = ["Viaje",
      "Placa",
      "Driver",
      "inicio",
      "fin",
      "Trips",
      "TripsOutTime",
      "TripsOnTime",
    ];

    this.totalPromInTime = 0
    this.totalPromOuitTime = 0
    this.dataObj = []
    for (var i in data) {
    	console.log('datadatadatadatadatadatadata : ', data)
      console.log(data[i].registerTime)

      data[i].trip = +i + 1

      data[i].startdate = new Date(data[i].startdate)
      data[i].endingdate = new Date(data[i].endTime)

      // data[i].startdate = data[i].startdate
      // data[i].startTime = data[i].startdate.toLocaleTimeString('es-CO', { hour12: true, hour: '2-digit', minute:'2-digit' })

      data[i].endingTime = data[i].endingdate.toLocaleString('es-CO', { hour12: true })
      // data[i].endingTime = data[i].endingTime.split(",")[1]

      data[i].startdate = data[i].startdate.toLocaleString('es-CO', { hour12: true })
      // data[i].startdate = data[i].startdate.split(",")[0]

      this.totalProm += data[i].passengerAmount

      this.totalPromInTime += data[i].onTimeValue
      this.totalPromOuitTime += data[i].outTimeValue


      // data[i].countBlock = data[i].tripsAmount
      this.setExcelData(data[i])
    }

    this.dataReport2 = new MatTableDataSource(data);

    setTimeout(() => {
      this.forceTablePaginator()
    },
      500);

    this.dataReport2.sort = this.sort;

    // Esconde el paginador porque no es posible cambair la paginación por problemas con el componente
  }

  forceTablePaginator() {
    try {
      // this.dataReport2.paginator = this.paginator;
      this.dataReport2.paginator._intl.itemsPerPageLabel = "Filas por Página:"
      $(".mat-paginator-page-size").css("display", "none")
    } catch (error) {
      try {
        this.dataReport2.paginator = this.paginator;
        this.dataReport2.paginator._intl.itemsPerPageLabel = "Filas por Página:"
        $(".mat-paginator-page-size").css("display", "none")
      } catch (error) {
        console.log(error)
      }
    }
  }

  toggleFilterMenu() {
    this.filterMenuVisible = !this.filterMenuVisible;
  }
  applyFilter(filterValue: string) {
    this.dataReport2.filter = filterValue.trim().toLowerCase();
    if (this.dataReport2.paginator) {
      this.dataReport2.paginator.firstPage();
    }
  }

  setExcelData(data){
    
    let item = {}
    item["Viaje"] = data.trip
    item["Placa"] = data.plate
    item["Conductor"] = data.driver
    item["inicio" ] = data.startdate
    item["fin" ] = data.endingTime
    item["Ctdad viajes" ] = data.tripsAmount
    

    this.dataObj.push(item)
    console.log(this.dataObj)
    
  }
  }

  


// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/timereportconsolidate/timereportconsolidate.component.ts